export const NOTIFICATIONS_API = "/api/notifications/";
export const NOTIFICATIONS_PAGE_SIZE = 250;
